import React, { Component } from 'react'
import { observer } from 'mobx-react'
import { withRouter } from 'react-router'
import omit from 'lodash/omit'
import { getUserInfo } from 'common/user'
import { submitAnswer } from 'common/api'
import Material from  '../Material'
import AnswerAnalysis from '../Material/AnswerAnalysis'
import styles from './questions.css'

@withRouter
@observer(['practiceStore'])
export default class writingQuestion extends Component {
  constructor(props) {
    super(props)
    this.state={
      clipboardData: "",
      answer:'',
      wordCount: 0
    }

    this.timer = null
    this.handleCopyClick = this.handleCopyClick.bind(this)
    this.handleCutClick = this.handleCutClick.bind(this)
    this.handlePasteClick = this.handlePasteClick.bind(this)
    this.handleTextCopy = this.handleTextCopy.bind(this)
    this.copyToMyClipboard = this.copyToMyClipboard.bind(this)
    this.handleChangeValue = this.handleChangeValue.bind(this)
  }

  componentDidMount () {
    this.timer = window.setInterval(this.autoSave.bind(this), 30000)
  }

  componentWillUnmount () {
    if (this.timer) { window.clearInterval(this.timer) }
  }

  autoSave () {
    const { practiceStore, params, location } = this.props
    const userAnswer = practiceStore.userAnswer.toJSON()

    if (userAnswer.some(item => !item.answer.text || item.isOverflow || item.isEmpty)) { return }

    submitAnswer({
      pid: params.pid,
      answer: sessionStorage.getItem('ALL_ANSWERS'),
      questions: JSON.stringify(practiceStore.questionIds),
      timeCost: practiceStore.costTime,
      exerciseId: sessionStorage.getItem('EXERCISE'),
      status: 0,
      token: getUserInfo() ? getUserInfo().token : null,
      ...omit(location.query, ['exerciseId'])
    })
  }

  handleCopyClick(e) {
    e.preventDefault()
    try {
      this.refs.textarea.focus()
      let result = document.execCommand('copy')
    } catch (e) {
      throw new Error(e.message)
    }
  }

  handleCutClick(e) {
    e.preventDefault()
    try {
      this.refs.textarea.focus()
      let result = document.execCommand('cut')
    } catch (e) {
      console.log(e.message)
    }
  }

  handlePasteClick() {
    let textarea = this.refs.textarea
    let start = textarea.selectionStart
    const { practiceStore, questionIndex } = this.props
    const userAnswer = practiceStore.userAnswer.toJSON()

    this.setState((prevState)=> {
      let before = prevState.answer.substr(0, start)
      let after = prevState.answer.substr(start)
      let clipData = prevState.clipboardData
      let newVal = before + clipData + after
      let wordCount = this.checkWordCount(newVal)
      userAnswer[questionIndex].answer.text = before + clipData + after
      userAnswer[questionIndex].answer.wordCount = wordCount
      userAnswer[questionIndex].isOverflow = practiceStore.textLimit > wordCount ? false : true
      userAnswer[questionIndex].isEmpty = wordCount === 0 ? true : false;
      practiceStore.saveAnswer(userAnswer)

      return {
        answer: before + clipData + after,
        wordCount: this.checkWordCount(before + clipData + after)
      }
    })

    textarea.focus()
  }

  copyToMyClipboard() {
    let textarea = this.refs.textarea
    let start = textarea.selectionStart
    let end = textarea.selectionEnd
    let clipboardData = textarea.value.substring(start, end)

    this.setState({clipboardData})
  }

  checkWordCount(inputStr) {
    var wordRegex = /(?:\b)?([\w]+?)\b/gmi;
    var specMatch = /([a-z]+?\'[a-z]+?\b)|(\$\d+(,\d+)+\b)/gmi;
    var match = null, wordCount = 0;
    inputStr = inputStr || '';
    inputStr = inputStr.replace(specMatch, 'combine');
    while ((match = wordRegex.exec(inputStr)) != null) {
      wordCount++;
    }
    return wordCount;
  }

  handleTextCopy() {
    this.copyToMyClipboard();
  }

  handleChangeValue(e) {
    const { practiceStore, questionIndex } = this.props
    const val = e.target.value
    const wordCount = this.checkWordCount(val)
    this.setState({answer: val, wordCount})
    const userAnswer = practiceStore.userAnswer.toJSON()
    userAnswer[questionIndex].answer.text = val
    userAnswer[questionIndex].isOverflow = wordCount > practiceStore.textLimit ? true : false
    userAnswer[questionIndex].answer.wordCount = wordCount
    userAnswer[questionIndex].isEmpty = wordCount === 0 ? true : false;

    practiceStore.saveAnswer(userAnswer)
  }

  renderWritingQuestion() {
    const { practiceStore, questionIndex } = this.props
    const writingUserAnswer = practiceStore.userAnswer.toJSON()
    const writingAnswer = writingUserAnswer[questionIndex] ?
    writingUserAnswer[questionIndex].answer.text : this.state.answer
    const wordCount = writingUserAnswer[questionIndex] ?
    writingUserAnswer[questionIndex].answer.wordCount : this.state.wordCount

    return (
      <div className={ styles.writing }>
        <div className={ styles.controls }>
          <button onClick={ this.handleCopyClick }>Copy</button>
          <button onClick={ this.handleCutClick }>Cut</button>
          <button onClick={ this.handlePasteClick }>Paste</button>
          { wordCount > practiceStore.textLimit ?
            <b className={ styles.errorTips }>字数超限</b> : null
          }
          <span>Word Count: <b>{ wordCount }</b></span>
        </div>
        <div className={ styles.textContent }>
          <textarea
            ref="textarea"
            spellCheck="false"
            onCopy={ this.handleTextCopy }
            onCut={ this.handleTextCopy }
            value={ writingAnswer }
            onChange={ this.handleChangeValue }
          />
        </div>
      </div>
    )
  }

  render (){
    const { practiceStore, question, answer_analysis } = this.props
    return (
      <div>
        { this.renderWritingQuestion() }
        { practiceStore.show.answer ?
          <AnswerAnalysis analysisAnswer={ answer_analysis } />
          : null
        }
      </div>
    )
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/Practice/Question/WritingQuestion.js
 **/